import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  IconButton,
  TableBody,
  makeStyles,
} from '@material-ui/core'

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'

import styles from './styles'

const useStyles = makeStyles(styles)

export default function CustomRow({ row }) {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  return (
    <>
      <TableRow key={row.id}>
        <TableCell align="left" className={classes.smallCell}>
          <IconButton size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>{row.equipment_type_name}</TableCell>
      </TableRow>
      {open && row?.data.length > 0 && (
        <TableRow>
          <TableCell className={classes.tableWrapper} colSpan={6}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Nome do Requerente</TableCell>
                  <TableCell>Marca</TableCell>
                  <TableCell>Nome do Equipamento</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {row.data.map((item) => (
                  <TableRow key={item.id}>
                    <TableCell>{item.cod_equipment}</TableCell>
                    <TableCell>{item.user_name}</TableCell>
                    <TableCell>{item.equipment_brand}</TableCell>
                    <TableCell>{item.equipment_description}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableCell>
        </TableRow>
      )}
    </>
  )
}

CustomRow.propTypes = {
  row: PropTypes.shape({
    equipment_type_name: PropTypes.string,
    id: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
}
